<div class="page-wrap height-100 default-bg">
  <div class="app-error">
    <div class="fix">
      <mat-icon class="error-icon" color="warn">error</mat-icon>
      <div class="error-text">
        <h1 class="error-title">404</h1>
        <div class="error-subtitle">{{'Page Not Found' | translate}}!</div>
      </div>
    </div>
    
    <div class="error-actions">
      <button 
      mat-raised-button 
      color="primary"
      class="mb-1 mr-05"
      (click)="back()">{{'Back to previous page' | translate}}</button>
    </div>
  </div>
</div>
